/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { filterBy, readOnly } from '@ember/object/computed';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import EnvironmentService from 'cio/services/environment';
import DS from 'ember-data';
import IdentityModel from 'cio/models/identity';
import { Task } from 'ember-concurrency';
import { IdentityMapping } from 'cio/utils/identity/types';

interface TwilioIdentitiesArgs {
  syncTask: Task<any, any>;
  lastUpdatedAt: number;
  identitiesInUse: string[];
  identitiesForSwitch: IdentityModel[];
  setIdentitiesMap: (identitiesMap: IdentityMapping) => void;
  saveIdentityTask: Task<unknown, any[]>;
  cancelMapping: () => unknown;
  needsMapping: boolean;
}

export default class TwilioIdentities extends Component<TwilioIdentitiesArgs> {
  @service environment!: EnvironmentService;
  @service store!: DS.Store;

  @tracked isAdding = false;

  @readOnly('environment.current.identities') identities!: IdentityModel[];
  @filterBy('identities', 'templateType', 'twilio') twilioIdentities!: IdentityModel[];
  @filterBy('twilioIdentities', 'autoGenerated', true) twilioPhoneNumbers!: IdentityModel[];
  @filterBy('twilioIdentities', 'autoGenerated', false) twilioAlphanumericIds!: IdentityModel[];

  @action
  toggleAdding() {
    this.isAdding = !this.isAdding;
  }
}
